const PUNCTUATION_PATTERN = /[.,/#'"()[\]]/g;

/**
 * Normalize a company legal name for comparison.
 * Collapses whitespace and ignores case and punctuation so
 * "Acme, LLC" matches "Acme LLC". Remaining spelling differences,
 * including legal suffixes, still fail.
 */
export function normalizeLegalName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(PUNCTUATION_PATTERN, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function legalNamesMatch(
  submittedName: string | null | undefined,
  websiteName: string | null | undefined
): boolean {
  if (!submittedName?.trim() || !websiteName?.trim()) {
    return false;
  }

  return normalizeLegalName(submittedName) === normalizeLegalName(websiteName);
}
